export default "__VITE_ASSET__o40NWLuD__"